<template>
  <OButton
    v-if="isVideoArticle && !isTestArticle"
    class="bg-[#2B64C1] text-white text-md font-bold rounded-md flex"
    :class="{ 'py-1': type === 'card' }"
  >
    {{ $t('main.watch-the-video') }}
    <OIcon class="ml-3 mt-1" icon="right-white" />
  </OButton>
</template>

<script>
import { defineComponent, inject } from '@nuxtjs/composition-api';
import { hasArticleCategory } from '@/modules/article/utils/articleUtils';
import { OButton, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  props: {
    type: {
      type: String,
      default: 'slider',
    },
  },
  components: { OButton, OIcon },
  setup() {
    const article = inject('article');
    const isVideoArticle = hasArticleCategory(article, 'Video');
    const isTestArticle = hasArticleCategory(article, 'Test');

    return { isVideoArticle, isTestArticle };
  },
});
</script>
